module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjIiIHZpZXdCb3g9IjAgMCA4IDIiIGZpbGw9Im5vbmUiPgogIDxwYXRoIGQ9Ik0xIDJDMC40NDc3MTUgMiAwIDEuNTUyMjggMCAxQzAgMC40NDc3MTUgMC40NDc3MTUgMCAxIDBIN0M3LjU1MjI4IDAgOCAwLjQ0NzcxNSA4IDFDOCAxLjU1MjI4IDcuNTUyMjggMiA3IDJIMVoiIGZpbGw9IiMxNzE3MTciLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/icon/sub.svg
// module id = 1505
// module chunks = 180